import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import { parse } from "date-fns";
import LocaleStrings from "@language";
import moment from "moment-timezone";
import _ from "lodash";
import { BaseComponent, LABEL_POSITION_TOP } from "@baseComponent";
import { ProductTextLocalized } from "@commonFunction";
import {
  validatePercent,
  DATE_FORMAT_WITH_TIME_WITH_SECOND,
  MIN_DATE_FORMAT,
} from "@constant";
import toast from "react-hot-toast";

// Import Actions
import {
  isOpenDiscManagModal,
  fetchProductsByCateSubCate,
  addDiscountMaster,
  addDiscountArea,
  fetchDiscountMaster,
  validatedDiscount,
  getSelectedDiscountObj,
  updateDiscountMaster,
  updateDiscountArea,
} from "@discountsmanagementActions";

// Functions Import
import { classNames, isEmpty } from "@commonFunction";

// Component Import

/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";

const FORM_NAME = "addDiscountForm";

class DiscountManagementModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      discounttype: "percentage",
      discountAreaType: "",
      selectedCateId: "",
      selectedSubCateId: "",
      selectedProductId: "",
      btnLoader: false,
      isBtnDisable: false,
    };

    // All refrence variables
    this.myRef = React.createRef();

    // All Binded Functions
    this.closeModal = this.closeModal.bind(this);
    this.handelDiscountType = this.handelDiscountType.bind(this);
  }

  /**** Fake Close ****/
  closeModal1() {}

  /**** Close Modal  ****/
  closeModal() {
    // Clear Single Discount Object (Pointing to)
    this.props.getSelectedDiscountObj({}, this.props.session);
    this.props.isOpenDiscManagModal(false);
    this.props.reset();
  }

  /**** OnClick Change ****/
  handelDiscountType(param) {
    this.setState({ discounttype: param });
  }

  /***** Form Submit *****/
  onFormSubmit(values) {
    /* Date validation */
    let validity_from = "";
    let validity_end = "";

    if (typeof values.validity_from === "string") {
      validity_from = parse(
        moment(values.validity_from).format("DD-MM-YYYY HH:mm:ss"),
        "dd-MM-yyyy HH:mm:ss",
        new Date()
      );
    } else {
      validity_from = values.validity_from;
    }

    if (typeof values.validity_end === "string") {
      validity_end = parse(
        moment(values.validity_end).format("DD-MM-YYYY HH:mm:ss"),
        "dd-MM-yyyy HH:mm:ss",
        new Date()
      );
    } else {
      validity_end = values.validity_end;
    }

    if (validity_end.getTime() < validity_from.getTime()) {
      toast.error(
        LocaleStrings.validity_end_date_and_greater_date_validation_text
      );
      return false;
    }

    /* Discount Validation */
    if (!_.isNaN(parseFloat(values.discount_percentage))) {
      if (parseFloat(values.discount_percentage) < 0) {
        toast.error(LocaleStrings.discount_int_validation);
        return false;
      }
    } else {
      toast.error(LocaleStrings.discount_invalid);
      return false;
    }

    let { singleDiscountObject } = this.props;
    let { discounttype } = this.state; // Get State Discount Type Value

    this.setState({ btnLoader: true }); // Start The button Loader
    this.setState({ isBtnDisable: true }); // Set Button Disabled

    /*** Validate [Product category,Product sub-category,Product] ***/
    if (
      parseInt(values.discounareaid) === 2 &&
      (values.idcategory === "" || values.idcategory === null)
    ) {
      toast.error(LocaleStrings.discount_product_category_error_text);
      this.setState({ btnLoader: false }); // Set The button Loader
      this.setState({ isBtnDisable: false }); // Set Button Disabled
      return false;
    }

    if (
      parseInt(values.discounareaid) === 3 &&
      (values.idsubcategory === "" || values.idsubcategory === null)
    ) {
      toast.error(LocaleStrings.discount_product_subcategory_error_text);
      this.setState({ btnLoader: false }); // Set The button Loader
      this.setState({ isBtnDisable: false }); // Set Button Disabled
      return false;
    }

    if (
      parseInt(values.discounareaid) === 4 &&
      (values.idproduct === "" || values.idproduct === null)
    ) {
      toast.error(LocaleStrings.discount_product_error_text);
      this.setState({ btnLoader: false }); // Set The button Loader
      this.setState({ isBtnDisable: false }); // Set Button Disabled
      return false;
    }

    if (_.isEmpty(singleDiscountObject)) {
      if (values.hasOwnProperty("id")) {
        values = _.omit(values, ["id"]);
      }
    }

    // date Validation
    if (
      moment(values.validity_from).unix() >= moment(values.validity_end).unix()
    ) {
      toast.error(LocaleStrings.invalid_date_range);
      this.setState({ btnLoader: false }); // End The button Loader
      this.setState({ isBtnDisable: false }); // End The button Loader
      return false;
    }

    let { initialValues } = this.props; // Get initialValues Object
    if (Object.keys(initialValues).length > 0) {
      // Checking if it's edit
      discounttype =
        discounttype === "" ? initialValues.discounttype : discounttype;
    }

    // DISCOUNT TYPE NOT SELECTED THEN SHOW ALERT
    if (isEmpty(discounttype)) {
      this.setState({ btnLoader: false });
      this.setState({ isBtnDisable: false });
      toast.error(LocaleStrings.discount_type_require);
      return false;
    } else {
      // PERCENTAGE VALIDATION
      if (
        discounttype === "percentage" &&
        validatePercent(values.discount_percentage) === false
      ) {
        this.setState({ btnLoader: false });
        this.setState({ isBtnDisable: false });
        toast.error(LocaleStrings.discount_percentage_not_valide);
        return false;
      }
    }

    /**** VALIDATE DISCOUNT OBJECT CREATION ****/
    let rulesobj = {
      idcategory:
        typeof values.idcategory != "undefined"
          ? parseInt(values.idcategory)
          : "",
      idsubcategory:
        typeof values.idsubcategory != "undefined"
          ? parseInt(values.idsubcategory)
          : "",
      idproduct:
        typeof values.idproduct != "undefined"
          ? parseInt(values.idproduct)
          : "",
      discounareaid:
        typeof values.discounareaid != "undefined"
          ? parseInt(values.discounareaid)
          : "",
    };

    if (values.id) {
      // IF ITS EDIT THEN SEND AVOBE(VALIDATION) OBJECT WITH DISCOUNT ID
      rulesobj["iddiscount"] = parseInt(values.id);
      rulesobj["discounareaid"] =
        initialValues.discountarea_by_iddiscount[0].id; // Discount Area
      // Old code - initialValues.discountarea_by_iddiscount.id; // Discount Area
    }

    this.props.validatedDiscount(this.props.session, rulesobj, (callBack) => {
      if (callBack.data.valid) {
        // Valide
        var obj = {
          discounttype: discounttype,
          title: _.trim(values.title),
          validity_from: moment(values.validity_from).format(
            DATE_FORMAT_WITH_TIME_WITH_SECOND
          ),
          validity_end: moment(values.validity_end).format(
            DATE_FORMAT_WITH_TIME_WITH_SECOND
          ),
          discount_percentage: values.discount_percentage,
          createdby: this.props.session.userid,
          callfrom: "makediscountvendor", // latest code
        };

        if (values.id) {
          // Edit Function call [ Edit Discount / Discount Area ]
          obj["id"] = values.id;
          obj["title"] = _.trim(values.title);
          this.props.updateDiscountMaster(
            this.props.session,
            obj,
            (callBack) => {
              var obj2 = {
                iddiscount: values.id,
                id: initialValues.discountarea_by_iddiscount.id,
                idcategory: values.idcategory,
                idsubcategory: values.idsubcategory,
                idproduct: values.idproduct,
                discounareaid: values.discounareaid,
              };

              // Update rules
              this.props.updateDiscountArea(
                this.props.session,
                obj2,
                (callBack) => {
                  toast.success(LocaleStrings.discount_added_successfully);
                  this.closeModal();
                  this.setState({ btnLoader: false });
                  this.setState({ isBtnDisable: false }); // Set Button Disabled false
                  // Clear Single Discount Object (Pointing to)
                  this.props.getSelectedDiscountObj({}, this.props.session);

                  // Refresh Discount Master List
                  this.props.fetchDiscountMaster(
                    this.props.session,
                    1,
                    (callBack) => {
                      this.props.updatePageNumber(1);
                    }
                  );
                  this.props.reset();
                }
              );
            }
          );
        } else {
          /**** Add function call ****/
          // Add Discount
          obj["title"] = _.trim(obj.title);

          this.props.addDiscountMaster(this.props.session, obj, (callBack) => {
            var obj2 = {
              iddiscount: callBack.data,
              idcategory: values.idcategory,
              idsubcategory: values.idsubcategory,
              idproduct: values.idproduct,
              discounareaid: values.discounareaid,
            };

            // Add riles
            this.props.addDiscountArea(this.props.session, obj2, (callBack) => {
              toast.success(LocaleStrings.discount_added_successfully);
              this.closeModal();
              this.setState({ btnLoader: false });
              this.setState({ isBtnDisable: false }); // Set Button Disabled false

              // Clear Single Discount Object (Pointing to)
              this.props.getSelectedDiscountObj({}, this.props.session);

              // Refresh Discount Master List
              this.props.fetchDiscountMaster(
                this.props.session,
                1,
                (callBack) => {
                  this.props.updatePageNumber(1);
                  // Close Modal
                }
              );
              this.props.reset();
            });
          });
        }
      } else {
        // Invalide
        this.setState({ btnLoader: false });
        this.setState({ isBtnDisable: false }); // Set Button Disabled false
        toast.error(LocaleStrings.similar_discount_already_available);
        return false;
      }
    });
  }

  // Discount Area On Ochange
  _handleDiscounareaScreen(e) {
    let areaType = "";
    if (e.target.value != "" && e.target.value != null) {
      areaType = _.find(this.props.discountArea, {
        id: parseInt(e.target.value),
      }).type;
    }
    this.setState({ discountAreaType: areaType });
  }

  // Category / Subcategory  / Product Select
  _handleIdcategoryScreen(e) {
    let selectedFiledName = e.target.name;
    let selectedFiledValue = e.target.value;

    if (selectedFiledName === "idcategory") {
      // Category
      this.setState({ selectedCateId: selectedFiledValue });

      let subCateID = this.state.selectedSubCateId;

      // If category || Sub-category present fetch Product
      this.props.fetchProductsByCateSubCate(
        this.props.session,
        selectedFiledValue,
        "",
        (callBack) => {}
      );
    } else if (selectedFiledName === "idsubcategory") {
      // Sub-category
      this.setState({ selectedSubCateId: selectedFiledValue });
      let cateID = this.state.selectedCateId;
      // If category || Sub-category present fetch Product
      this.props.fetchProductsByCateSubCate(
        this.props.session,
        cateID,
        selectedFiledValue,
        (callBack) => {}
      );
    } else if (selectedFiledName === "idproduct") {
      // product
      this.setState({ selectedProductId: selectedFiledValue });
    } else {
    }
  }

  render() {
    let { initialValues, language, handleSubmit, productSubCategory } =
      this.props;
    let { discountAreaType, selectedCateId, discounttype } = this.state;

    let modalHeadText = "";
    let modalFooterText = "";

    if (Object.keys(initialValues).length > 0) {
      //EDIT
      discounttype =
        discounttype === ""
          ? initialValues.discounttype
          : this.state.discounttype;

      discountAreaType =
        discountAreaType === ""
          ? _.find(this.props.discountArea, {
              id: parseInt(initialValues.discounareaid),
            }).type
          : discountAreaType;

      selectedCateId =
        selectedCateId === "" ? initialValues.idcategory : selectedCateId;

      modalHeadText = LocaleStrings.edit_discount;
      modalFooterText = LocaleStrings.update_discount;
    } else {
      //ADD
      modalHeadText = LocaleStrings.add_new_discount;
      modalFooterText = LocaleStrings.add_new_discount;
    }

    var discountAreaOptions = []; // Discount Area
    var discountCateOptions = []; // Category
    var discountSubCateOptions = []; // Sub-Category
    var discountProductOptions = []; // Product

    //Discount Area Object Creation
    _.forEach(this.props.discountArea, function (value) {
      var obj = {
        name: ProductTextLocalized(value.area_en, value.area_ar, language),
        value: value.id,
      };

      discountAreaOptions.push(obj);
    });

    if (
      discountAreaType === "category" ||
      discountAreaType === "subcategory" ||
      discountAreaType === "product"
    ) {
      //Discount Category Object Creation
      _.forEach(this.props.productCategory, function (value) {
        // Checking isactive true
        if (value.isactive) {
          var obj = {
            name: ProductTextLocalized(
              value.categoryname_en,
              value.categoryname_ar,
              language
            ),
            value: value.id,
          };

          discountCateOptions.push(obj);
        }
      });
    }

    if (discountAreaType === "subcategory" || discountAreaType === "product") {
      //Discount Sub-Category Object Creation

      let filterSubcateArr = _.filter(this.props.productSubCategory, {
        categoryid: parseInt(selectedCateId),
      });

      _.forEach(filterSubcateArr, function (value) {
        // Filter sub sub category list whose parent id
        let subSubCategory = _.filter(productSubCategory, {
          parentid: parseInt(value.id),
        });

        if (subSubCategory.length > 0) {
          // If sub sub category is present
          _.forEach(subSubCategory, function (subSubObject, subSubIndex) {
            // loop through Sub sub category
            if (subSubObject.isactive) {
              var obj = {
                name: ProductTextLocalized(
                  value.subcategoryname_en +
                    " - " +
                    subSubObject.subcategoryname_en,
                  value.subcategoryname_ar +
                    " - " +
                    subSubObject.subcategoryname_ar,
                  language
                ),
                value: subSubObject.id,
              };

              discountSubCateOptions.push(obj);
            }
          });
        } else {
          // if sub sub category is not there for current subcategory
          if (value.isactive) {
            var obj = {
              name: ProductTextLocalized(
                value.subcategoryname_en,
                value.subcategoryname_ar,
                language
              ),
              value: value.id,
            };

            discountSubCateOptions.push(obj);
          }
        }
      });
    }

    if (discountAreaType === "product") {
      //Discount Product (On select Cate | Subcate) Object Creation
      _.forEach(this.props.productByCateSubCate, function (value) {
        if (
          parseInt(value.isactive) === 1 &&
          parseInt(value.isapproved) === 1 &&
          parseInt(value.isdeleted) === 0
        ) {
          var obj = {
            name: ProductTextLocalized(
              value.productname_en,
              value.productname_ar,
              language
            ),
            value: value.id,
          };

          discountProductOptions.push(obj);
        }
      });
    }
    // console.log("discountProductOptions", discountProductOptions);
    return (
      <>
        <Transition.Root show={this.props.isDiscManageOpen} as={Fragment}>
          <Dialog
            as="div"
            static
            className="fixed z-10 inset-0 overflow-y-auto"
            open={this.props.isDiscManageOpen}
            onClose={this.closeModal1}
            initialFocus={this.myRef}>
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0">
                <Dialog.Overlay className="fixed inset-0 bg-ternary bg-opacity-75 transition-opacity" />
              </Transition.Child>
              <span
                className="sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true">
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <div
                  className="inline-block align-bottom bg-custWhite rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 sticky-top scrollbar-hide"
                  style={{ padding: 0 }}>
                  {/* MODAL HEADER */}
                  <div className="grid grid-cols-6 border-b-2 border-quaternary pb-4 sticky-header z-10">
                    <div></div>
                    <div className="flex flex-wrap content-center justify-center mt-4 col-span-4">
                      <div className="text-lg leading-6 font-medium text-secondary">
                        {modalHeadText}
                      </div>
                    </div>
                    <div className="absolute top-0 right-0 pt-4 pr-4 ">
                      <button
                        type="button"
                        className="btn-closeModal"
                        ref={this.myRef}
                        onClick={this.closeModal}>
                        <span className="sr-only">{LocaleStrings.close}</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                  <form
                    className=" "
                    onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
                    {/* MODAL HEADER ENDS */}
                    <div className="p-6 space-y-8">
                      <Field
                        name="title"
                        label={LocaleStrings.discount_title}
                        placeholder={LocaleStrings.enter_discount_title}
                        type="text"
                        component={this.renderFieldText}
                        mandatory="true"
                        labelposition={LABEL_POSITION_TOP}
                        classNameLabel="text-sm font-medium text-secondary"
                      />

                      <Field
                        name="validity_from"
                        label={LocaleStrings.validity_starting_date}
                        placeholder={LocaleStrings.select_validity_from}
                        component={this.renderDateTimePickerWithLabel1}
                        mandatory="true"
                        minDate={
                          Object.keys(initialValues).length > 0
                            ? ""
                            : new Date(moment().format(MIN_DATE_FORMAT))
                        }
                        // selected={moment()}

                        classNameLabel="text-box-lable"
                        className={"cust-input-field"}
                      />

                      <Field
                        name="validity_end"
                        label={LocaleStrings.validity_end_date}
                        placeholder={LocaleStrings.select_validity_until}
                        component={this.renderDateTimePickerWithLabel1}
                        mandatory="true"
                        minDate={
                          Object.keys(initialValues).length > 0
                            ? ""
                            : new Date(moment().format(MIN_DATE_FORMAT))
                        }
                        // selected={moment()}
                        className={"cust-input-field"}
                        classNameLabel="text-box-lable"
                      />

                      <div className="relative mt-1 rounded-md ">
                        <Field
                          name="discount_percentage"
                          label={LocaleStrings.discount}
                          placeholder={LocaleStrings.discount}
                          type="text"
                          component={this.renderFieldTextDiscount}
                          labelposition={LABEL_POSITION_TOP}
                          mandatory="true"
                          className="cust-input-field"
                          classNameLabel="text-box-lable"
                          discountType={discounttype}
                          handelDiscountType={this.handelDiscountType}
                        />
                      </div>
                      <div>
                        <p className="text-xs font-semibold text-secondary">
                          {LocaleStrings.discount_applicable_rule}
                        </p>
                        <p className="mt-1 text-xs text-ternary">
                          {LocaleStrings.discount_applicable_rule_subtext}
                        </p>
                      </div>
                      <div>
                        <Field
                          name="discounareaid"
                          label={LocaleStrings.select_discount_area}
                          placeholder={LocaleStrings.select}
                          component={this.renderSelect}
                          mandatory="true"
                          labelposition={LABEL_POSITION_TOP}
                          opts={discountAreaOptions}
                          classNameLabel="block text-box-lable"
                          onChange={this._handleDiscounareaScreen.bind(this)}
                          isdisabled={
                            Object.keys(initialValues).length > 0 ? "true" : ""
                          }
                          className={
                            Object.keys(initialValues).length > 0
                              ? "bg-gray-200 cust-input-field2"
                              : "cust-input-field2"
                          }
                          // value={this.props.initialValues.type}
                        />
                      </div>
                      <div>
                        <Field
                          name="idcategory"
                          label={LocaleStrings.discount_product_category}
                          placeholder={LocaleStrings.select}
                          component={this.renderSelect}
                          mandatory="false"
                          labelposition={LABEL_POSITION_TOP}
                          opts={discountCateOptions}
                          isdisabled={
                            Object.keys(initialValues).length > 0 ? "true" : ""
                          }
                          className={
                            Object.keys(initialValues).length > 0
                              ? "bg-gray-200 cust-input-field2"
                              : "cust-input-field2"
                          }
                          classNameLabel="block text-box-lable"
                          onChange={this._handleIdcategoryScreen.bind(this)}
                        />
                      </div>
                      <div>
                        <Field
                          name="idsubcategory"
                          label={LocaleStrings.discount_product_subcategory}
                          placeholder={LocaleStrings.select}
                          component={this.renderSelect}
                          mandatory="false"
                          labelposition={LABEL_POSITION_TOP}
                          opts={discountSubCateOptions}
                          isdisabled={
                            Object.keys(initialValues).length > 0 ? "true" : ""
                          }
                          className={
                            Object.keys(initialValues).length > 0
                              ? "bg-gray-200 cust-input-field2"
                              : "cust-input-field2"
                          }
                          classNameLabel="block text-box-lable"
                          onChange={this._handleIdcategoryScreen.bind(this)}
                        />
                      </div>
                      <div>
                        <Field
                          name="idproduct"
                          label={LocaleStrings.discount_product}
                          placeholder={LocaleStrings.select}
                          component={this.renderSelect}
                          mandatory="false"
                          labelposition={LABEL_POSITION_TOP}
                          opts={discountProductOptions}
                          isdisabled={
                            Object.keys(initialValues).length > 0 ? "true" : ""
                          }
                          className={
                            Object.keys(initialValues).length > 0
                              ? "bg-gray-200 cust-input-field2"
                              : "cust-input-field2"
                          }
                          classNameLabel="block text-box-lable"
                          onChange={this._handleIdcategoryScreen.bind(this)}
                        />
                      </div>
                    </div>
                    <div className="p-6 border-t-2 border-quaternary">
                      {/* Footer */}
                      <button
                        type="submit"
                        disabled={this.state.isBtnDisable}
                        className={classNames(
                          this.state.isBtnDisable ? "cursor-not-allowed" : "",
                          "btn-primary"
                        )}>
                        <svg
                          className={classNames(
                            this.state.btnLoader ? "" : "hidden",
                            "animate-spin-medium h-5 w-5 rounded-full mx-2"
                          )}
                          viewBox="0 0 1024 1024"
                          focusable="false"
                          data-icon="loading"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true">
                          <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                        </svg>{" "}
                        {modalFooterText}
                      </button>
                    </div>
                  </form>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
      </>
    );
  }
}

function validate(values) {
  var errors = {};

  var requiredFields = ["title", "discount_percentage", "discounareaid"];

  var requiredDateFields = ["validity_from", "validity_end"];

  requiredFields.forEach((field) => {
    if (!values[field] || _.trim(values[field]) === "") {
      errors[field] = LocaleStrings.required;
    }
  });

  requiredDateFields.forEach((field) => {
    if (!values[field] || values[field] === "") {
      errors[field] = LocaleStrings.required;
    }
  });

  return errors;
}

function mapStateToProps(state) {
  var { session, user } = state;
  let singleDiscountObject = state.singleDiscountObject;

  return {
    session,
    user,
    isLoggedIn: state.isLoggedIn,
    language: state.language,
    isDiscManageOpen: state.isDiscManageModalopen,
    discountArea: state.discountArea
      ? state.discountArea.data != "undefined"
        ? state.discountArea.data
        : []
      : [],
    productCategory: state.productCategory
      ? state.productCategory.data != "undefined"
        ? state.productCategory.data
        : []
      : [],
    productSubCategory: state.productSubCategory
      ? state.productSubCategory.data != "undefined"
        ? state.productSubCategory.data
        : []
      : [],
    criteriaMaster: state.criteriaMaster
      ? state.criteriaMaster.data != "undefined"
        ? state.criteriaMaster.data
        : []
      : [],
    productByCateSubCate: state.productByCateSubCate
      ? state.productByCateSubCate.data !== "undefined"
        ? state.productByCateSubCate.data
        : []
      : [],
    initialValues: singleDiscountObject,
    singleDiscountObject: singleDiscountObject,
  };
}

export default connect(mapStateToProps, {
  isOpenDiscManagModal,
  fetchProductsByCateSubCate,
  addDiscountMaster,
  addDiscountArea,
  fetchDiscountMaster,
  validatedDiscount,
  getSelectedDiscountObj,
  updateDiscountMaster,
  updateDiscountArea,
})(
  reduxForm({
    validate,
    form: "addDiscountForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(DiscountManagementModal)
);
